import React from 'react';

export default (props) => <div className={"inset-text "+(props.position?props.position+"-quote":"middle-quote")}><blockquote><span className="big-quote">{props.quote}</span><br/><span className="quote-credit">{props.credit?"—"+props.credit:""}</span></blockquote></div>


// WEBPACK FOOTER //
// ./src/js/components/Quote/Quote.jsx